fragment PeopleIqFilterSettingsFragment on FilterSettingsPayload {
    contactInformationList {
        contactInformation {
            id
            name
        }
        isBlocked
    }
    jobFieldList {
        jobField {
            id
            name
        }
        isBlocked
    }
    managementLevelList {
        managementLevel {
            id
            name
        }
        isBlocked
    }
}
